import { render, staticRenderFns } from "./ModalTambahKunjungan.vue?vue&type=template&id=3fdd9289"
import script from "./ModalTambahKunjungan.vue?vue&type=script&lang=js"
export * from "./ModalTambahKunjungan.vue?vue&type=script&lang=js"
import style0 from "./ModalTambahKunjungan.vue?vue&type=style&index=0&id=3fdd9289&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports